import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import "./../../../css/app.css";
import { useAlert } from "react-alert";
import { useHistory } from "react-router-dom";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import mqtt_topics from "../../../mqtt/mqtt_topics";
import { confirmAlert } from "react-confirm-alert";
import common from "../../../core/common";

import auth from "../../../core/auth";
const appparameters = require("../../../core/common.jsx");

const GridItemView = (props) => {
  const alert = useAlert();
  const onlinetimeoutinmilisec = 360000; //6 mins 360 sec 360000 msec
  let onlinecheckinterval;
  let history = useHistory();
  const [state, setState] = useStateIfMounted({
    siteId: props.siteId,
    siteInformation: props.siteInformation,
    siteDescription: props.siteDescription,
    lastseen: props.lastseen,
    status: props.status,
    deleted: false,
    latitude: props.latitude,
    longitude: props.longitude,
    mail: props.mail,
    index: props.index,
    subtype: props.subtype,
  });
  //const [state, setState] = useStateIfMounted(props);
  let client = mqtt_topics.mqttclientinstance;
  let when_lasttime_recieved_status = now();
  const target_topic =
    mqtt_topics.fixed_topic_part + props.mac + "/" + mqtt_topics.status_topic;

  function now() {
    return Math.floor(Date.now() / 1000);
  }
  function listendevicestatus() {
    client.subscribe(target_topic);
    client.on("message", handleMqttMessage);
  }

  useEffect(() => {
    // Update local state when props change
    setState({
      ...state,
      lastseen: props.lastseen,
    });

    // Your existing useEffect code...
  }, [props]);

  function handleMqttMessage(topic, message) {
    if (topic == target_topic) {
      try {
        when_lasttime_recieved_status = now();
        // console.log( "when_lasttime_recieved_status " + when_lasttime_recieved_status);
        // message is Buffer
        message = JSON.parse(message.toString());
        setState({
          ...state,
          status: message,
          lastseen:
            message.Fault != undefined && message.Warnings != undefined
              ? "Fault: " +
                message.Fault.toString() +
                "\n Warning: " +
                message.Warnings.toString()
              : message.Fault != undefined
                ? "Fault: " + message.Fault.toString()
                : message.Warnings != undefined
                  ? "Warning: " + message.Warnings.toString()
                  : "Online",
        });

        /* localStorage.setItem(
          props.mac + "_grid_state",
          JSON.stringify({
            ...state,
            status: message,
            lastseen:
              message.Fault != undefined && message.Warnings != undefined
                ? "Fault: " +
                  message.Fault.toString() +
                  "\n Warning: " +
                  message.Warnings.toString()
                : message.Fault != undefined
                ? "Fault: " + message.Fault.toString()
                : message.Warnings != undefined
                ? "Warning: " + message.Warnings.toString()
                : "Online",
          })
        );
        localStorage.setItem(props.mac + "_grid_time", now());*/
      } catch (error) {
        //console.log(message);
      }
    }
  }

  function checkifstillonline() {
    let been = now() - when_lasttime_recieved_status;
    //console.log("been " + been + "now()" + now());
    if (been >= onlinetimeoutinmilisec / 1000) {
      if (props.lastseen == "N/A") {
        //offline
        setState({
          ...state,
          status: {},
          lastseen: "Offline",
        });
      } else {
        setState({
          ...state,
          status: {},
          lastseen: props.lastseen.includes("ago")
            ? props.lastseen
            : "6 minutes ago",
        });
      }

      /*localStorage.setItem(
        props.mac + "_grid_state",
        JSON.stringify({
          ...state,
          lastseen: state.lastseen.includes("ago") ? state.lastseen : "Offline",
        })
      );
      localStorage.setItem(props.mac + "_grid_time", now());*/
    }
  }
  useEffect(() => {
    //get the last state if available
    /*let savedstate = localStorage.getItem(props.mac + "_grid_state");
    if (savedstate != undefined && savedstate != "") {
      savedstate = JSON.parse(savedstate);
      if (savedstate.status != undefined) {
        //check if data valid
        if (
          now() - Number(localStorage.getItem(props.mac + "_grid_time")) <
          6 * 60
        ) {
          //check data late 6 mins timeout
          setState(savedstate);
        }
      }
    }*/

    localStorage.setItem(props.mac + "_grid_time", now() - 1000 * 60);

    listendevicestatus();
    checkifstillonline();
    onlinecheckinterval = setInterval(function () {
      checkifstillonline();
    }, onlinetimeoutinmilisec);
  }, []);

  //when componenet unmount
  useEffect(
    () => () => {
      client.unsubscribe(target_topic);
      clearInterval(onlinecheckinterval);
      client.removeListener("message", handleMqttMessage);
    },
    [],
  );

  function displayiconaccordingtostatus() {
    if (state.status != undefined) {
      let imgsource = "";
      let imgtitle = "";
      if (
        state.status.Fault != undefined &&
        state.status.Warnings != undefined
      ) {
        imgsource = require("./../../../images/status/fault-warning.png");
        imgtitle = "On Fault And Warning";
      } else if (state.status.Fault != undefined) {
        imgsource = require("./../../../images/status/fault.png");
        imgtitle = "On Fault!";
      } else if (state.status.Warnings != undefined) {
        imgsource = require("./../../../images/status/warning.png");
        imgtitle = "On Warning!";
      } else if (
        state.status.State != undefined ||
        state.lastseen == "Online"
      ) {
        imgsource = require("./../../../images/status/online.png");
        imgtitle = "Online";
      } else {
        imgsource = require("./../../../images/status/offline.png");
        imgtitle = "Offline";
      }
      return (
        <img
          className="table_icon"
          src={imgsource}
          title={imgtitle}
          align="right"
        />
      );
    } else {
      return <label>N/A</label>;
    }
  }
  function connecttolivedisplay() {
    if (
      props.entered_pass == undefined ||
      props.entered_pass == props.userpass ||
      props.entered_pass == props.clientpass ||
      props.entered_pass == props.seniorpass ||
      props.entered_pass == props.saspass
    ) {
      mqtt_topics.choosenmac = props.mac;
      mqtt_topics.choosenid = props.siteId;
      mqtt_topics.choosendevicefirmwaretype = props.subtype;
      mqtt_topics.latitude = props.latitude;
      mqtt_topics.longitude = props.longitude;
      //props.parentPropsHistory.push("/ld");
      localStorage.setItem("userpass_of_" + props.mac, props.userpass);
      localStorage.setItem("clientpass_of_" + props.mac, props.clientpass);
      localStorage.setItem("seniorpass_of_" + props.mac, props.seniorpass);
      localStorage.setItem("saspass_of_" + props.mac, props.saspass);
      localStorage.setItem("designtype_of_" + props.mac, props.designtype);
      localStorage.setItem("type_of_" + props.mac, props.type);
      localStorage.setItem("timezone_of_" + props.mac, props.timezone);
      localStorage.setItem("sv_of_" + props.mac, props.softwareversion);
      localStorage.setItem("fu_of_" + props.mac, props.fu);
      localStorage.setItem("lr_of_" + props.mac, props.lr);
      localStorage.setItem("fl_of_" + props.mac, props.fl);
      localStorage.setItem("fr_of_" + props.mac, props.fr);
      localStorage.setItem(
        "entered_pass_of_" + props.mac,
        props.entered_pass == undefined ? "000" : props.entered_pass,
      );
      history.push({
        pathname: "/ld",
        props: props,
      });
    } else {
      alert.show(
        "The device password has been changed. Please re-add the device using the new password.",
        {
          type: "error",
          position: "middle",
        },
      );
    }
  }

  const options = {
    customUI: ({ onClose }) => {
      return (
        <div className="alert">
          <h1 className="alert__title">
            Remove {state.siteId} from your account.
          </h1>
          <p className="alert__body">Proceed ?</p>
          <button
            onClick={() => {
              removesitefromaccount();
              onClose();
            }}
            className="btn btn-primary"
          >
            Yes
          </button>
          &nbsp;
          <button className="btn btn-secondary" onClick={onClose}>
            No
          </button>
        </div>
      );
    },
  };

  function removesitefromaccount() {
    let user_information = auth.getUserData();

    fetch(appparameters.backend_app_url + "/frontend/removesitefromaccount", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user: {
          username: user_information.username,
          token: user_information.token,
          device_id: props.index,
        },
      }),
    })
      .then((res) => res.json())
      .then((response) => {
        //console.log("request result from removesitefromaccount ");
        //console.log(response);
        if (response) {
          alert.show("Deleted successfully, will disappear shortly.", {
            type: "success",
            position: "middle",
          });
          setState({
            ...state,
            deleted: true,
          });
        } else {
          alert.show("Failed to delete.", {
            type: "error",
            position: "middle",
          });
        }
        //setLoading(false);
      });
  }

  const someEventHandler = (event) => {
    history.push({
      pathname: "/edit",
      state: state,
    });
  };

  function openeditpanel() {
    someEventHandler(); //props.parentPropsHistory.push("/edit");
  }
  if (state.deleted) {
    return <div>{null}</div>;
  } else {
    return (
      <div className="col">
        <div className="card text-center bg-light mb-3 gridviewcards">
          <div className="card-header">
            <img
              className="table_icon"
              src={require("./../../../images/edit_siteidescription.png")}
              onClick={() => openeditpanel()}
              title="Edit"
              align="left"
            />
            {state.siteId}
            {displayiconaccordingtostatus()}
          </div>
          <div className="card-body">
            <p className="card-title" title="Site information">
              {state.siteInformation == "" ? "N/A" : state.siteInformation}
            </p>
            <p className="card-text" title="Site description">
              {state.siteDescription == "" ? "N/A" : state.siteDescription}
            </p>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => connecttolivedisplay()}
            >
              Connect
            </button>
            <hr />
            <Popup
              trigger={
                <button className="btn btn-warning btn-sm"> Info </button>
              }
              position="bottom center"
            >
              <center>
                <small className="text-muted">
                  <strong>Mac Address : </strong>
                  {common.companyconstantpartofmac + props.mac}
                </small>
                <br></br>
                <p className="card-text">
                  <small className="text-muted">
                    <strong>Hardware Version : </strong>
                    {props.hardwareversion}
                  </small>
                  <br></br>
                  <small className="text-muted">
                    <strong>Software Version : </strong>
                    {props.softwareversion}
                  </small>
                  <br></br>
                  <small className="text-muted">
                    <strong>Revision Number : </strong>
                    {props.revisionnumber}
                  </small>
                  <br></br>
                  <small className="text-muted">
                    <strong>Serial Number : </strong>
                    {props.serialnumber}
                  </small>
                  <br></br>
                  <small className="text-muted">
                    <strong>Hardware Type : </strong>
                    {props.type}
                  </small>
                  <br></br>
                  <small className="text-muted">
                    <strong>Software Type : </strong>
                    {props.subtype}
                  </small>
                  <br></br>
                  <small className="text-muted">
                    <strong>SD Presence : </strong>
                    {props.SDPresence == 0 ? "Unplugged" : "Plugged"}
                  </small>
                </p>
              </center>
            </Popup>
            &nbsp;
            <button
              className="btn btn-danger btn-sm"
              onClick={() => confirmAlert(options)}
            >
              Remove
            </button>
          </div>

          <div className="card-footer">{state.lastseen}</div>
        </div>
      </div>
    );
  }
};
export default GridItemView;
